define('view/module/menu/MenuListItemView',['require','lib/view/LayoutView','lib/Navigation'],function (require) {

    var LayoutView = require('lib/view/LayoutView');
    var Navigation = require('lib/Navigation');
    /**
     * Menu module item view
     *
     * @class MenuListModuleItemView
     */
    return LayoutView.extend({

        template: '#menu_list_item_view',
        activeItemName : null,

        initialize : function (options) {
            LayoutView.prototype.initialize.apply(this, arguments);

            var instance = this;

            this.listenTo(Backbone.history, 'route', function (route) {
                instance.activeItemName = route.getOption('menuItem');
                instance.render();

        /*        var activeItem = "menu_" + route.getOption('menuItem');

                if(activeItem == instance.model.get('name')){
                    instance.model.set('active_item', true);
                }*/
            });
        },

        /**
         * Pass additional data to view
         *
         * @return Object
         */
        serializeData: function () {
            var isActive = this.activeItemName === this.model.get('route');
            var type = this.model.get('type');

            if(!this.activeItemName){
                isActive = false;
            }else if(type === 'html' || type === 'link'){
                var fragment = Navigation.routeFragment(); // without query and trailing slash
                if(fragment && fragment.indexOf('page/') !== -1) {
                    var pageSeo = String(fragment).replace('page/', '');
                    if(pageSeo === this.model.get('seo_url')){
                        isActive = true;
                    }
                }
            }
            
            if (isActive) {
                var menuItem = this.model;
                setTimeout(function () {
                    //NB timeout 0 for proper first event pass
                    Backbone.Wreqr.radio.vent.trigger('module', 'activated', {
                        'module': 'menu',
                        'item': menuItem
                    });
                }, 0);
            }

            return _.extend(
                LayoutView.prototype.serializeData.apply(this), {
                    'active_item' : isActive
                }
            );
        },

        childViewOptions: function(model, index) {
            return {
                is_footer: this.getOption('is_footer')
            }
        },

        getTemplate: function () {
            if(this.getOption('is_footer')){
                return  '#menu_list_item_footer_view';
            }
            return this.template;
        }

    });

});
